<template>
  <div class="props-group">
      <el-form-item label="省级必填">
        <el-checkbox v-model="component.properties.addressRequired.province"></el-checkbox>
      </el-form-item>
      <el-form-item label="市级必填">
        <el-checkbox v-model="component.properties.addressRequired.city"></el-checkbox>
      </el-form-item>
      <el-form-item label="区级必填">
        <el-checkbox v-model="component.properties.addressRequired.area"></el-checkbox>
      </el-form-item>
      <el-form-item label="地址必填">
        <el-checkbox v-model="component.properties.addressRequired.address"></el-checkbox>
      </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-address',
  props: [ 'component' ],
  watch: {
    'component.properties.addressRequired.province' (val) {
      if (val === false) {
        this.component.properties.addressRequired.city = false
        this.component.properties.addressRequired.area = false
      }
    },
    'component.properties.addressRequired.city' (val) {
      if (val === true) {
        this.component.properties.addressRequired.province = true
      } else {
        this.component.properties.addressRequired.area = false
      }
    },
    'component.properties.addressRequired.area' (val) {
      if (val === true) {
        this.component.properties.addressRequired.province = true
        this.component.properties.addressRequired.city = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/componentAttr/address.vue